import { render, staticRenderFns } from "./OfficePromotions.vue?vue&type=template&id=462436e4"
import script from "./OfficePromotions.vue?vue&type=script&lang=ts"
export * from "./OfficePromotions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports